import React, { useEffect } from 'react';
import { ModalHeader, ModalBody, Typography, Button, LoadingButton, ModalFooter, } from '@one-thd/sui-atomic-components';
import { setRemoveUserOverlayAnalytics } from '../../../utils/add-manage-user-analytics';
export var DeleteUserModal = function (_a) {
    var user = _a.user, isLoading = _a.isLoading, onConfirmDelete = _a.onConfirmDelete, hideModal = _a.hideModal;
    var firstName = user.firstName, lastName = user.lastName, role = user.role;
    useEffect(function () {
        setRemoveUserOverlayAnalytics();
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalHeader, { onClose: hideModal }, "Do You Want To Remove This User?"),
        React.createElement(ModalBody, null,
            React.createElement("div", { className: "sui-flex sui-mb-4" },
                React.createElement(Typography, { variant: "body-base", weight: "bold", "data-qm-mask": "" },
                    firstName,
                    " ",
                    lastName),
                "\u00A0",
                React.createElement(Typography, { variant: "body-base", color: "subtle", weight: "bold" },
                    "(",
                    role,
                    ")")),
            React.createElement(Typography, { variant: "body-base" }, "You'll still be able to review previous purchases made by this user.")),
        React.createElement(ModalFooter, { position: "end" },
            React.createElement("div", { className: "sui-flex sui-gap-4 sm:sui-gap-4 sui-flex-col-reverse sui-w-full sm:sui-flex-row sm:sui-w-auto" },
                React.createElement(Button, { variant: "secondary", onClick: hideModal, "data-testid": "no-btn" }, "No"),
                React.createElement(LoadingButton, { loading: isLoading, variant: "primary", onClick: onConfirmDelete, "data-testid": "yes-remove-user-btn" }, "Yes, Remove User")))));
};
DeleteUserModal.displayText = 'DeleteUserModal';
